import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { subjectsApi } from '../subjects';

export const subjectsKeys = ['admin', 'timetable', 'subjects'] as const;

export function useSubjectsQuery() {
  return useQuery({ queryKey: subjectsKeys, queryFn: () => subjectsApi.list() });
}

export function useCreateSubjectMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof subjectsApi.create>[0]) => subjectsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: subjectsKeys }),
  });
}

export function useUpdateSubjectMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof subjectsApi.update>[1] }) =>
      subjectsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: subjectsKeys }),
  });
}

export function useDeleteSubjectMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => subjectsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: subjectsKeys }),
  });
}
